import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { waitForAsync } from '@angular/core/testing';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { fetchUserPreferances, updateUserPreferances } from 'src/app/common';
import { Cookies, RequestURL } from 'src/app/Constants/app.constants';
import { RestService } from 'src/app/Services/Rest/rest.service';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class UserPreferencesService {
  constructor(
    private restService: RestService,
    private httpClient: HttpClient
  ) {}

  fetchPreferences() {
    // var preferances = localStorage.getItem("my_pref");
    // if(preferances != null)
    //   return;

    let customHttpHeader = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        //  'client-security-token': apiAuthToken
      }),
    };

    fetchUserPreferances.userId = localStorage.getItem('userId') || '';

    this.restService.postRestCall(
      fetchUserPreferances,
      RequestURL.fetchUserPreferances,
      (data: any) => {
        localStorage.setItem('my_pref', JSON.stringify(data));
      },
      customHttpHeader
    );
  }

  isShowProductVideo() {
    var preferances = localStorage.getItem('my_pref');
    /*if(preferances == null) {
          await this.fetchPreferences();
      }*/
    var isShowProductVideo = false;
    if (preferances) {
      var prefJSON = JSON.parse(localStorage.getItem('my_pref') || '{}');
      isShowProductVideo = prefJSON.show_product_video;
    }
    return isShowProductVideo;
  }

  setShowProductVideo(isShowProdVideo: any) {
    //Update in Database
    this.updatePreferances(isShowProdVideo);

    //Update in localstorage
    // var preferances = localStorage.getItem("my_pref");
    var prefJSON = JSON.parse(localStorage.getItem('my_pref') || '{}');
    prefJSON.show_product_video = isShowProdVideo;
    localStorage.setItem('my_pref', JSON.stringify(prefJSON));
  }

  /**
   * this method is common for update prefreances in the database on the basis of check box value
   */
  updatePreferances(isShowProdVideo: any) {
    updateUserPreferances.userId = localStorage.getItem('userId') || '';
    updateUserPreferances.showProductGuideVideo = isShowProdVideo;

    let customHttpHeader = {
      responseType: 'text',
      headers: new HttpHeaders({}),
    };

    this.restService.postRestCall(
      updateUserPreferances,
      RequestURL.updateUserPreferances,
      (data: any) => {
        // console.log(data);
      },
      customHttpHeader
    );
  }
}
